
export class ExpressionCategories {
    static readonly DesignerComplex = "Designer:Complex";
}
